import { render, staticRenderFns } from "./ReturnedBoxPopup.vue?vue&type=template&id=46bce7a9"
import script from "./ReturnedBoxPopup.vue?vue&type=script&lang=js"
export * from "./ReturnedBoxPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports